const Constants = {
  httpAuthToken: "bearer obfMAswessMOadBilayIivzirAppppEmaiL",
  locale_en_QA: "en-QA",
  locale_ar_QA: "ar-QA",
};
export default Constants;
